<!--
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : CryptoCurrency - CryptoApp 1 This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2023-present initappz.
-->
<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
